import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
//number format plugin
import Autocomplete from "@material-ui/lab/Autocomplete";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import MessageBox from "../../components/MessageBox/MessageBox";
import { SELECTION_CHANGED } from "@material-ui/data-grid";

import {PDFDownloadLink} from '@react-pdf/renderer';
import {CashVoucherPdf} from "../../components/PDF/CashVoucherPdf";
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #4aba4a",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(137, 200, 59, 0.09)",
		padding: "1rem",
		border: "1.5px solid #4aba4a",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #4aba4a",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	miniTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
});

const ColorButton = withStyles(() => ({
	root: {
		color: "#fff",
		backgroundColor: "#4caf50",
		"&:hover": {
			backgroundColor: "#fff",
			color: "#4caf50",
		},
	},
}))(Button);

const CashVoucherAllocatedView = () => {
	const { cvno, branchidno } = useParams();
	const [fundFrom, setFundFrom] = useState([]);
	const [payTo, setPayTo] = useState('');
	const [amount, setAmount] = useState('');
	const [releasedAmount, setReleasedAmount] = useState('');
	const [notes, setNotes] = useState('');
	const classes = useStyles();
	// const [poTotal, setPoTotal] = useState(0);

	const [cvDate, setCvDate] = React.useState(format(new Date(), "yyyy-MM-dd"));
	const [fundsDate, setFundsDate] = React.useState(format(new Date(), "yyyy-MM-dd"));

	const [accountIndex, setAccountIndex] = useState(null);

	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(true);

	const [showModal, setShowModal] = useState(false);
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");

	const [status, setStatus] = useState("");
	const [approver, setApprover] = useState("");
	const [change, setChanged] = useState(0);
	const [settledDate, setSettledDate] = React.useState(format(new Date(), "yyyy-MM-dd"));
	const [settledBy, setSettledBy] = useState('');

	let history = useHistory();

	useEffect(() => {
		getCashVoucherDetails();
	}, []);

	const checkType = [
		{
			type:'Petty Cash'
		},
		{
			type:'Cash Sales'
		}
	]

	const checkSupplierProps = {
		options: checkType,
		getOptionLabel: (option) => option.type,
	};


	const getCashVoucherDetails = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'cv_view', {
			params:{
				cvno: cvno,
				jc_u_idno: branchidno
			}
		}).then((res)=>{
			setPayTo(res.data.data[0].payto);
			setAmount(res.data.data[0].released_amount);
			setNotes(res.data.data[0].notes);
			setCvDate(res.data.data[0].trandate);
			setFundsDate(res.data.data[0].fundsdate);
			setFundFrom(res.data.data[0].fundfrom);
			setStatus(res.data.data[0].status);
			setApprover(res.data.data[0].approver);
			setChanged(res.data.data[0].change);
			setSettledDate(res.data.data[0].settled_date);
			setSettledBy(res.data.data[0].settled_by);
			setReleasedAmount(res.data.data[0].actual_amount);
			let fundfrom = res.data.data[0].fundfrom;
			setAccountIndex(checkType.findIndex(check => check.type === fundfrom));
		}).catch((error)=>{
			// console.log(error.message);
		});
		await getCashVoucherDetailspdf();
	}

	useEffect(() => {
		if(fundFrom && payTo && amount && notes && cvDate && fundsDate) {
			setBtnDisabled(false); // re-enable
		}else{
			setBtnDisabled(true); // re-enable	
		}
	}, [fundFrom, payTo, amount, notes, cvDate, fundsDate]);

	const handleCashDateChange = (date) => {
		date = format(date, "yyyy-MM-dd");
		setCvDate(date);
		
	};
	const handleFundsDateChange = (date) => {
		date = format(date, "yyyy-MM-dd");
		setFundsDate(date);
		
	};

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const [cvDetails, setCvDetails] = useState([]);
	const [showPDF, setShowPdf] = useState(false);
	const [items, setItems] = useState([]); //data to display in table

	const getCashVoucherDetailspdf = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'cv_view_print', {
			params:{
				cvno,
				jc_u_idno: branchidno
			}
		}).then((res)=>{
			setCvDetails(res.data.data);
			setItems(res.data.data.item);
			setShowPdf(true);
		}).catch((error)=>{
			// console.log(error.message);
		});
	}

	return (
		<div className="page">

			<div className="page-header">
				<div className="page-icon">
					<AccountBalanceWalletIcon />
				</div>
				<NavLink to={"/account"}><h2 style={{color:"black"}}>Accounts</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<NavLink to={"/account/cash-voucher-transaction-history"}><h2 style={{color:"black"}}>Cash Voucher Transaction History</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2>Cash Voucher Allocated View #{cvno}</h2>
			</div>
			{accountIndex != null ? (<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
								Cash Voucher Information
								</div>
								<div className={classes.title}>
								Cash Voucher Information
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
							</Grid>
							<Grid
							
								item
								xs={2}
								className={classes.buttonContainer}
							>
							</Grid>
							<Grid container spacing={2}>
								<Grid item xs="6" lg="4" xl="3">
									<form noValidate autoComplete="off">
										<MuiPickersUtilsProvider utils={DateFnsUtils}>
											<KeyboardDatePicker
											disableToolbar
											variant="inline"
											format="MMM dd, yyyy"
											id="date-picker-inline"
											label="Cash Voucher Date"
											value={cvDate}
											onChange={handleCashDateChange}
											inputVariant="outlined"
											margin="normal"
											disabled={true}
											className={classes.date}
											KeyboardButtonProps={{
												"aria-label": "change date",
											}}/>
										</MuiPickersUtilsProvider>
										<MuiPickersUtilsProvider utils={DateFnsUtils}>
											<KeyboardDatePicker
											disableToolbar
											variant="inline"
											format="MMM dd, yyyy"
											id="date-picker-inline"
											label="Funds Date"
											value={fundsDate}
											onChange={handleFundsDateChange}
											inputVariant="outlined"
											margin="normal"
											disabled={true}
											className={classes.date}
											KeyboardButtonProps={{
												"aria-label": "change date",
											}}/>
										</MuiPickersUtilsProvider>
										<MuiPickersUtilsProvider utils={DateFnsUtils}>
											<KeyboardDatePicker
											disableToolbar
											variant="inline"
											format="MMM dd, yyyy"
											id="date-picker-inline"
											label="Settled Date"
											value={settledDate}
											inputVariant="outlined"
											margin="normal"
											disabled={true}
											className={classes.date}
											KeyboardButtonProps={{
												"aria-label": "change date",
											}}/>
										</MuiPickersUtilsProvider>
										<Autocomplete
													{...checkSupplierProps}
													id="auto-complete"
													autoComplete
													includeInputInList
													defaultValue={checkType[accountIndex]}
													className={classes.autoComplete}
													disabled={true}
													renderInput={(params) => (
														<TextField
															{...params}
															label="Select Account"
															margin="normal"
															variant="outlined"
														/>
													)}
													onChange={(event, newValue) => {
														if (!newValue == "" || !newValue == null){
															// console.log(newValue);
															setFundFrom(newValue.type);
														}
													}}
										/>
										<TextField
													style={{marginTop:"8px"}}
													id="outlined-required"
													label="Pay To"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={payTo} //to avoid label overlapping bug
													onChange={(e)=>{setPayTo(e.target.value)}}
													InputProps={{
														readOnly: true,
													  }}
										/>	
										<TextField
													style={{marginTop:"12px"}}
													id="outlined-required"
													label="Amount"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={amount} //to avoid label overlapping bug
													onChange={(e)=>{setAmount(e.target.value)}}
													InputProps={{
														readOnly: true,
													  }}
										/>
										<TextField
													style={{marginTop:"12px"}}
													id="outlined-required"
													label="Released Amount"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={releasedAmount} //to avoid label overlapping bug
													onChange={(e)=>{setAmount(e.target.value)}}
													InputProps={{
														readOnly: true,
													  }}
										/>
									</form>
								</Grid>
								<Grid item xs="6" lg="4" xl="3">
								<TextField
													style={{marginTop:"12px"}}
													id="outlined-required"
													label="Status"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={status} //to avoid label overlapping bug
													InputProps={{
														readOnly: true,
													  }}
										/>
										<TextField
													style={{marginTop:"12px"}}
													id="outlined-required"
													label="Notes"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={notes} //to avoid label overlapping bug
													onChange={(e)=>{setNotes(e.target.value)}}
													InputProps={{
														readOnly: true,
													  }}
										/>
										<TextField
													style={{marginTop:"12px"}}
													id="outlined-required"
													label="Change"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={change} //to avoid label overlapping bug
													InputProps={{
														readOnly: true,
													  }}
										/>
										<TextField
													style={{marginTop:"12px"}}
													id="outlined-required"
													label="Approved By"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={approver} //to avoid label overlapping bug
													InputProps={{
														readOnly: true,
													  }}
										/>
										<TextField
													style={{marginTop:"12px"}}
													id="outlined-required"
													label="Settled By"
													variant="outlined"
													fullWidth={true}
													className={classes.field}
													value={settledBy} //to avoid label overlapping bug
													InputProps={{
														readOnly: true,
													  }}
										/>
								</Grid>
					        </Grid>
						</Grid>
					</div>	
					</Card>				
					{/* <div className={classes.buttonContainer}>
					<Button disabled={btnDisabled} variant="contained" color="primary" onClick={()=>{approve_cv()}}>
						Approve
					</Button> 
					</div>*/}
					<div className={classes.buttonContainer}>
						{
							showPDF ?
								<PDFDownloadLink
									document={<CashVoucherPdf cvDetails={cvDetails} items={items[0]}/>}
									fileName={"CashVoucherPrint"+cvno+".pdf"}
								>
									{({ blob, url, loading, error }) =>
									<ColorButton
										variant="contained"
										color="primary"
										classes={{
											root: classes.root,
											disabled: classes.disabled
										}}
									>
										{loading ? "Loading document..." : "Export PDF"}
									</ColorButton>
									}
								</PDFDownloadLink> : ""
						}
					</div>
			</div>) : (<div></div>)}
		</div>
	);
};

export default CashVoucherAllocatedView;
